import {
  Avatar,
  AvatarGroup,
  LiveIndicator,
  PresenceStack,
} from "@/components/domain/avatar"

const people = [
  { name: "Nadia Alvarez", identity: "n.alvarez@pyxisrc.com" },
  { name: "Marcus Chen", identity: "m.chen@pyxisrc.com" },
  { name: "Priya Rao", identity: "p.rao@pyxisrc.com" },
  { name: "Kostya Vasiliev", identity: "kostya@pyxisrc.com" },
  { name: "Viet-Anh Nguyen", identity: "va@pyxisrc.com" },
]

export function AvatarPreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Domain component
        </div>
        <h1 className="mt-1 text-display text-text">Avatar</h1>
        <p className="mt-2 max-w-2xl text-body text-text-2">
          Hash-to-hue: the same identity gets the same colour on every screen,
          without a table to maintain.
        </p>
      </header>

      <Section title="Sizes">
        {(["xs", "sm", "md", "lg"] as const).map((s) => (
          <Avatar key={s} name="Nadia Alvarez" identity="n.alvarez@pyxisrc.com" size={s} />
        ))}
      </Section>

      <Section title="Same identity, always the same hue">
        {people.map((p) => (
          <div key={p.identity} className="flex flex-col items-center gap-1.5">
            <Avatar name={p.name} identity={p.identity} size="md" />
            <span className="font-id text-micro text-text-3">{p.name.split(" ")[0]}</span>
          </div>
        ))}
      </Section>

      <Section title="AvatarGroup">
        <AvatarGroup people={people} max={3} />
        <AvatarGroup people={people} max={5} />
      </Section>

      <Section title="LiveIndicator">
        <LiveIndicator state="live" />
        <LiveIndicator state="reconnecting" />
        <LiveIndicator state="offline" />
      </Section>

      <Section title="PresenceStack (who is looking at this thread)">
        <PresenceStack
          presence={[
            { name: "Nadia Alvarez", identity: "n.alvarez@pyxisrc.com", state: "live" },
            { name: "Marcus Chen", identity: "m.chen@pyxisrc.com", state: "live" },
          ]}
        />
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-4">{children}</div>
    </section>
  )
}
